var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor b2cargo-login-user" }, [
    _c("div", { staticClass: "b2cargo-login-user-info-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [_vm._v("Username")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: "Username",
              rows: 1,
            },
            model: {
              value: _vm.clone.uname,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "uname", $$v)
              },
              expression: "clone.uname",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "b2cargo-login-user-info-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [_vm._v("Password")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: "Password",
              rows: 1,
            },
            model: {
              value: _vm.clone.pass,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "pass", $$v)
              },
              expression: "clone.pass",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "inputTitle mt-5 mb-2 font-weight-bold" }, [
      _vm._v(_vm._s(_vm.$t("chatbotv2.followingAttributesFilled"))),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "next-step-filled-items-wrapper" },
      _vm._l(_vm.nextStepFilledValue, function (attr) {
        return _c(
          "div",
          { key: attr, staticClass: "logos middle-section" },
          [
            _c("AttributeIconPreview", { attrs: { attribute: attr } }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ml-2" },
              [_c("AttributeLabel", { attrs: { attribute: attr } })],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }